<template>
  <Dialog
    :visible.sync="display"
    :style="{ width: '90vw' }"
    :modal="true"
    :closable="false"
  >
    <template #header>
      <span>{{ $t("Confirmation.Confirmation") }}</span>
    </template>

    {{ question }}
    <div class="field-checkbox" v-if="checkBoxMessage">
      <Checkbox inputId="customCheckBox" v-model="checked" :binary="true" />
      <label for="customCheckBox" style="margin-bottom: 0px">{{
        checkBoxMessage
      }}</label>
    </div>
    <template #footer>
      <Button
        :label="$t('Confirmation.Yes')"
        icon="pi pi-check"
        @click="onClick(true)"
      />
      <Button
        :label="showNoButton ? $t('Confirmation.No') : $t('Confirmation.Cancel')"
        icon="pi pi-times"
        @click="onClick(false)"
        class="p-button-secondary"
      />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: "Confirmation",
  props: ["display", "question", "checkBoxMessage", "showNoButton"],
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    onClick(value) {
      if(this.checked){
        this.$emit("confirmed", value, true);
      }
      else{
              this.$emit("confirmed", value, false);
      }
    },
  },
};
</script>
